import React, { useState } from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import { displayField, isNotEmpty, isEmptyVal } from "../../../utils/helpers";
import { relative } from "path";

const PhoneCell = ({
  rowData,
  positionFromRight = "60",
  phoneIndex = "mobile",
  stdCodeIndex = "country_code",
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
  phoneIndex?: any;
  stdCodeIndex?: any;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const handleEvent = (eventKey: any) => {
    console.log(eventKey);
  };
  const countryCode = isNotEmpty(rowData[stdCodeIndex])
    ? "+" + rowData[stdCodeIndex] + " "
    : "";
  const speaker = isNotEmpty(rowData[phoneIndex]) ? (
    <Popover title={t("MOBILE") + ":"}>
      <p>
        <p> {displayField(countryCode + rowData[phoneIndex])}</p>
      </p>
    </Popover>
  ) : (
    <Popover title={t("MOBILE") + ":"}>
      <p>{t("NA")}</p>
    </Popover>
  );
  return (
    <Cell {...props}>
      <Whisper
        placement="left"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a
          onClick={() => {
            handleEvent("mobile");
          }}
        >
          {displayField(rowData[phoneIndex])}
        </a>
      </Whisper>
    </Cell>
  );
};

export default PhoneCell;
